/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2292
 */

"use strict"

module.exports = {
  SourceCode: require(/* 2293 */"./2293/index")
}
